export enum AnswerSize {
  SMALL = 'small',
  MEDIUM =  'medium',
  LARGE = 'large',
  THIRD = 'third',
  FULL = 'full'
}